import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';

export class GaTrackingProceedToCheckoutClickEvent implements GATrackingEvent {

  constructor(
    private event: string,
    private category: string,
    private action: string,
    private label?: string
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ProceedToCheckout;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.event,
      category: this.category,
      label: this.label,
      gtmCustom: {
        action: this.action,
        category: this.category,
      }
    };
  }

}
